import Layout from '../components/Layout'
import Lineloading from '../components/UI/Lineloading'
import { useState, useEffect } from 'react'
import Skills from '../components/Skills'
import Services from '../components/Services'
import Work from '../components/Work'
import Contact from '../components/Contact'
const Home = () => {
    const [spinner, setSpinner] = useState(true)
    useEffect(() => {
        setTimeout(() => {
            setSpinner(false)
        }, 3000);
    })
    return (
        <>
            {
                spinner ? <Lineloading />
                    :
                    <div>
                        <div id='layout'>
                            <Layout />
                        </div>
                        <div id='skills'>
                            <Skills />
                        </div>
                        <div id='services'>
                            <Services />
                        </div>
                        <div id='work'>
                            <Work />
                        </div>
                        <div id='contact'>
                            <Contact />
                        </div>
                    </div>
            }
        </>
    )
}

export default Home
